import { format } from "date-fns";

export function formatShiftTimeShort(iso: string): string {
  return format(new Date(iso), "HH:mm");
}

export function formatShiftDuration(clockIn: string, clockOut: string): string {
  const ms = new Date(clockOut).getTime() - new Date(clockIn).getTime();
  if (ms <= 0) return "";
  const hours = Math.floor(ms / 3_600_000);
  const mins = Math.floor((ms % 3_600_000) / 60_000);
  if (hours > 0) return `${hours} ຊມ ${mins} ນ`;
  return `${mins} ນາທີ`;
}
